/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";

import BreadCrumbsHome from "./BreadCrumbsHome";

/**
 - `translate` : i18n translation key if available *
 - `title` : plain text if no translation or dynamic info needed *
 - `page` : makes the element clickable (link to this route) * */
export interface BreadCrumbItem {
    title?: string;
    page?: string;
    translate?: string;
}

/** * Breadcrumbs for navigation.
 *  Displays a hierarchical navigation path. The first element is always a link to home.
 *  @param `home` : Link to parent
 *  @param `items` : @see {@link BreadCrumbItem}
*/
const BreadCrumbs = ({ home, items  }: {home?: string, items: BreadCrumbItem[]}) => {
    if (!items || !items.length) {
        return null;
    }

    const {length} = items;
    return (
        <div className="kt-subheader__breadcrumbs">
            <BreadCrumbsHome home={home} />
            <span className="kt-subheader__breadcrumbs-separator" />
            {items.map((item, index) => (
                <React.Fragment key={`bc${index}`}>
                    {typeof item.page !== 'undefined' ? (
                        <Link className="kt-subheader__breadcrumbs-link" to={`/${item.page}`}>
                            {!item.translate ? (
                                item.title
                            ) : (
                                <FormattedMessage id={item.translate} defaultMessage={item.title} />
                            )}
                        </Link>
                    ) : (
                        <div className="kt-subheader__breadcrumbs-link">
                            {!item.translate ? (
                                item.title
                            ) : (
                                <FormattedMessage id={item.translate} defaultMessage={item.title} />
                            )}
                        </div>
                    )}
                    {length !== index + 1 && (
                        <span className="kt-subheader__breadcrumbs-separator" />
                    )}
                </React.Fragment>
            ))}
        </div>
    );
}

export default BreadCrumbs;
